import { Component, OnInit, NgZone } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { AuthService } from "src/app/services/auth.service";
import { CrudService } from "src/app/services/crud.service";
import { UtilService } from "src/app/services/util.service";
import { ResponseAPI, UserType } from "src/models/user.model";
import { NavController, LoadingController, Platform } from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { Events } from "src/app/services/events-service.service";
import { MapsService } from "src/app/services/maps.service";
import { Capacitor } from "@capacitor/core";

@Component({
    selector: "app-driver-accept",
    templateUrl: "./driver-accept.page.html",
    styleUrls: ["./driver-accept.page.scss"],
    providers: [],
    standalone: false
})
export class DriverAcceptPage implements OnInit {
  isOpenCanceling: boolean;
  formCancelation: UntypedFormGroup;
  race: any = { raceType: "" };
  dataCorridaAgendada = new Date();
  claim: UserType;
  userType = UserType;
  isPwa = false;
  eta = "";
  origin: any;
  destination: any;
  constructor(
    private fb: UntypedFormBuilder,
    private auth: AuthService,
    private crud: CrudService,
    private util: UtilService,
    private navCtrl: NavController,
    public load: LoadingController,
    private _ngZone: NgZone,
    private platform: Platform,
    private _events: Events,
    private _mapsService: MapsService
  ) { }

  async ngOnInit() {
    await this._mapsService.loadGoogleMaps();
    this.isPwa = !Capacitor.isNativePlatform();
    this.race = JSON.parse(localStorage.getItem("currentRace"));
    this.dataCorridaAgendada = new Date(this.race.dataAgendamentoCorrida);
    this.formCancelation = this.fb.group({
      motivoCancelamento: [""],
      id: [this.race.id],
      canceladoPor: [this.auth.user.name],
      voltarParaEmDisputa: [false],
    });

    this.claim = await this.auth.getClaim();

    if (!this.race.raceType.includes('Scheduled')) {
      let service = new google.maps.DistanceMatrixService();

      this.origin = new google.maps.LatLng(!this.race.motorista.latitude ? "28.4297768" : this.race.motorista.latitude, !this.race.motorista.longitude ? "-81.4713984" : this.race.motorista.longitude)
      this.destination = new google.maps.LatLng(this.race.latitudeOrigem, this.race.longitudeOrigem);

      await service.getDistanceMatrix({
        origins: [this.origin],
        destinations: [this.destination],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC
      }, (e) => {


        if (e.rows[0].elements[0].status === "OK" || e.rows[0].elements[0].status !== "ZERO_RESULTS")
          this.eta = e.rows[0].elements[0].duration.text;
      });
    }
  }

  ionViewWillEnter() {
    this._events.publish('update:establishments');
  }

  ionViewWillLeave() {
    this._events.publish('clear:location');
  }



  cancelRace(): void {
    this._ngZone.run(() => {
      this.isOpenCanceling = true;
    });
  }
  async return() {
    await this.navCtrl.navigateForward("call/call-driver");
  }

  async newTrip() {
    await this.return();
  }
  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.load.create(loadingProps);
    return await loading.present();
  }
  async postReason() {
    if (this.formCancelation.invalid) {
      return false;
    }
    await this.showLoading();
    this.crud
      .postData("Corrida/cancelar-corrida", null, this.formCancelation.value)
      .subscribe(
        async (response: ResponseAPI) => {
          if (response.success) {
            this.isOpenCanceling = false;
            await this.load.dismiss();
            await this.util.showToast("Your information has been sent.");
            await this.navCtrl.navigateBack("call/call-driver");
          }
        },
        async (error) => {
          this.isOpenCanceling = false;
          await this.load.dismiss();
          await this.navCtrl.navigateBack("call/call-driver");
          await this.util.showToast("An error occured");
        }
      );
  }
}
